import { Component } from '@angular/core';
import { ImojePaymentService } from '../../services/imoje-payment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { mapTo, switchMap, tap } from 'rxjs/operators';
import { PaymentService } from '../../services/payment.service';
import { CardPaymentSummary } from '../../models/card-payment-summary.model';

@Component({
  selector: 'app-card-form',
  templateUrl: './card-payment.component.html',
  styleUrls: ['./card-payment.component.scss']
})
export class CardPaymentComponent {
  data$: Observable<CardPaymentSummary>;

  constructor(
    private imojePaymentService: ImojePaymentService,
    private paymentService: PaymentService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.data$ = combineLatest([this.activatedRoute.data, this.activatedRoute.paramMap]).pipe(
      tap(console.log),
      switchMap(([data, paramMap]) => this.loadData(paramMap, data))
    );
  }

  startPaymentAgain() {
    this.paymentService.startPaymentAgain().subscribe(() => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    });
  }

  private loadData(paramMap, data) {
    const { personalData, paymentType } = data;

    return this.imojePaymentService.createPaymentCardWidget(paramMap.get('token'), personalData, paymentType).pipe(
      mapTo({
        paymentType,
        personalData
      })
    );
  }
}
